module.exports = __webpack_public_path__ + "static/img/guanxijiezhuan.ac6c03ed.png";